// libs
import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { History } from 'history';

// reducers
import connectApp from './app/reducer';
import landingpage from './landingpage/reducers';
import details from './details/reducer';
import cart from './cart/reducer';
import widgets from './widgets/reducer';
import listing from './listing/reducer';
import connectRemoteConfig from './remoteConfigs/reducer';
import globalSearch from './globalSearch/reducer';
import abExperiments from '@nykaa/experiment-sdk/store/reducer';
import wishlist from './wishlist/reducer';
import cms from './cms/reducer';
import topBanner from './topBanner/reducer';
import { DeviceType } from './app/types';
import listingV2 from './listingV2/reducer';
import hybridPDP from './hybridPDP/reducer';
import dynamicPage from './dynamicPage/reducer';
import couponPage from './couponPage/reducer';
import imageSearchReducer from './imageSearch/reducer';
import appMigration from './appMigration/reducer';

interface RootReducer {
  history: History;
  ssrHeaders?: Record<string, string>;
  cookies?: Record<string, string>;
  asyncReducers?: any;
  remoteConfigs?: Record<string, any>;
  deviceType?: DeviceType;
  internalUserExp?: boolean;
  storeId?: string;
}

const createRootReducer = ({
  history,
  ssrHeaders,
  cookies,
  asyncReducers,
  remoteConfigs,
  deviceType,
  internalUserExp,
  storeId
}: RootReducer) =>
  combineReducers({
    app: connectApp({ ssrHeaders, cookies, deviceType, internalUserExp, storeId }),
    landingpage,
    cart,
    details,
    widgets,
    listing,
    globalSearch,
    abExperiments,
    wishlist,
    remoteConfigs: connectRemoteConfig(remoteConfigs),
    router: connectRouter(history),
    cms,
    topBanner,
    listingV2,
    hybridPDP,
    dynamicPage,
    couponPage,
    imageSearchReducer,
    appMigration,
    ...asyncReducers,
  });

export default createRootReducer;
